export function assertUnreachable(value: never): never {
  throw new Error(`unexpected value: ${value}`)
}
